import { FC } from 'react';

import { RemountableErrorBoundary } from 'modules/error';
import { RefreshButton } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { USER_INSIGHTS_RUM_ATTRIBUTES } from '../../constants';
import { ErrorMessage } from './ErrorMessage';
import { useTranslation } from '../../hooks';

export const testIds = {
  refreshButton: 'refresh-button',
};

export const AudienceInsightsErrorBoundary: FC<
  React.PropsWithChildren<unknown> & { isSection?: boolean }
> = ({ children, isSection = false }) => {
  const { t } = useTranslation();

  return (
    <RemountableErrorBoundary
      errorMarkup={({ isRemounting, remount }) => (
        <ErrorMessage
          isSection={isSection}
          title={t('insights.errorBoundary.title')}
          description={
            <>
              {t('insights.errorBoundary.subtitle')}
              <br />
              {t('insights.errorBoundary.description')}
            </>
          }
          content={
            <RefreshButton
              data-test={testIds.refreshButton}
              onClick={remount}
              isRefreshing={isRemounting}
              isDisabled={isRemounting}
              variant={BUTTON_VARIANTS.PRIMARY}
              size={BUTTON_SIZES.MEDIUM}
            >
              {t(`insights.errorBoundary.${isRemounting ? 'loadingMessage' : 'callToAction'}`)}
            </RefreshButton>
          }
        />
      )}
      {...USER_INSIGHTS_RUM_ATTRIBUTES}
    >
      {children}
    </RemountableErrorBoundary>
  );
};
